import {
  formatValueWithNotation,
  returnDecimalFormatting,
} from "@/lib/globalFormatterHelper";
import { NotationToDecimalValueType } from "@/lib/interfaces and Enums/TYPENotations";

// LQC-2153: FRN quotes are always discount margin, the coupon is a rate.
export const FRN_QUOTED_MARGIN_NOTATION: NotationToDecimalValueType = "bps";
export const FRN_CURRENT_COUPON_NOTATION: NotationToDecimalValueType = "%";

// Value only, no notation symbol - used for copy/paste.
export function formatFRNBlockValue(
  value: any,
  notation?: NotationToDecimalValueType,
): string {
  if (value === null || value === undefined || value === "") return "";
  if (!notation) return String(value);
  const asNumber = Number(value);
  if (isNaN(asNumber)) return String(value);
  return returnDecimalFormatting(asNumber, notation);
}

// Value plus notation symbol - used for display.
export function formatFRNBlockValueWithNotation(
  value: any,
  notation?: NotationToDecimalValueType,
): string {
  const formattedValue = formatFRNBlockValue(value, notation);
  if (!formattedValue) return "";
  return formatValueWithNotation(formattedValue, notation);
}

export function referenceIndexValueFormatter(params: any): string {
  return formatFRNBlockValue(params.value);
}

export function quotedMarginValueFormatter(params: any): string {
  return formatFRNBlockValue(params.value, FRN_QUOTED_MARGIN_NOTATION);
}

export function currentCouponValueFormatter(params: any): string {
  return formatFRNBlockValue(params.value, FRN_CURRENT_COUPON_NOTATION);
}
